import { jsx as _jsx } from "react/jsx-runtime";
import { interpolate } from '../interpolate';
import { sanitizeRichText } from '../sanitize';
export function ParagraphBlock({ block, vars, className }) {
    const html = sanitizeRichText(interpolate(block.content ?? '', vars));
    const alignClass = block.textAlign === 'center' ? 'text-center' : 'text-left';
    return (_jsx("div", { className: className ?? `tutorial-prose text-base leading-relaxed text-slate-700 ${alignClass}`, 
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: { __html: html } }));
}
